(ns ui.view.entity-graph.edge
  (:require [re-frame.core :as rf]
            [common.util :as cu]
            [ui.view.entity-graph.model :as m]
            [ui.view.entity-graph.components.edge :as edge-components]))

(def types
  {:custom-edge #'edge-components/custom-edge})

(defn handle-changes
  [ctx changes]
  (let [selects (->> changes
                     (filterv (fn [change]
                                (= (:type change) "select"))))
        selected (->> selects
                      (into #{}
                            (comp
                             (filter :selected)
                             (map :id)
                             (map parse-long))))
        unselected (->> selects
                        (into #{}
                              (comp
                               (remove :selected)
                               (map :id)
                               (map parse-long))))
        deletes (->> changes
                     (filterv (fn [{:keys [type]}]
                                (= type "remove"))))]
    (when (cu/one-element? deletes)
      (rf/dispatch [m/start-delete (assoc ctx
                                          :connector-id
                                          (-> deletes first :id parse-long))]))
    (when (or (seq selected)
              (seq unselected))
      (rf/dispatch-sync [m/select-edges ctx {:select selected
                                             :unselect unselected}]))))
